/** Flush hooks before clearing auth on 401 (e.g. debounced caption autosave). */

const flushers = new Set();

export function registerPendingSave(flushFn) {
  if (typeof flushFn !== 'function') return () => {};
  flushers.add(flushFn);
  return () => flushers.delete(flushFn);
}

export async function flushPendingSavesBeforeLogout() {
  await Promise.allSettled(
    [...flushers].map((fn) => Promise.resolve().then(() => fn())),
  );
}
